import createIcon from '../../createIcon';

/**
 * @component @name NewLabel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNSAxMS41TDE3LjEzIDE3LjY2QzE2Ljc2IDE4LjE4IDE2LjE1IDE4LjUgMTUuNSAxOC41SDEyLjVWMTIuNUg5LjVWOS41SDMuNVY2LjVDMy41IDUuNCA0LjQgNC41IDUuNSA0LjVIMTUuNUMxNi4xNSA0LjUgMTYuNzYgNC44MSAxNy4xMyA1LjM0TDIxLjUgMTEuNVpNMTAuNSAxNC41SDcuNVYxMS41SDUuNVYxNC41SDIuNVYxNi41SDUuNVYxOS41SDcuNVYxNi41SDEwLjVWMTQuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NewLabel = createIcon('NewLabel', [
  [
    'path',
    {
      d: 'M21.5 11.5L17.13 17.66C16.76 18.18 16.15 18.5 15.5 18.5H12.5V12.5H9.5V9.5H3.5V6.5C3.5 5.4 4.4 4.5 5.5 4.5H15.5C16.15 4.5 16.76 4.81 17.13 5.34L21.5 11.5ZM10.5 14.5H7.5V11.5H5.5V14.5H2.5V16.5H5.5V19.5H7.5V16.5H10.5V14.5Z',
      key: '1fp276',
    },
  ],
]);

export default NewLabel;
